<template>
    <div
        v-if="attachment"
        class       = "inbox-attachment"
        @click.stop = "onDetail"
        :style      = "isSelected ? 'background: #e8e8e8' : ''"
    >
        <div class="v-flex">
            <div class="v-flex">
                <v-icon color="red" style="margin-top: -1px">
                    {{ icon }}
                </v-icon>
                <v-icon color="primary" class="pl-1" style="margin-top: -1px" v-if="attachment.confirmed">
                    mdi-check-circle
                </v-icon>
                <v-icon color="red" class="pl-1" style="margin-top: -1px" v-if="attachment.ignore">
                    mdi-delete-outline
                </v-icon>
                <a>
                    <v-icon color="red" class="pl-1" style="margin-top: -1px" v-if="attachment.duplicate">
                        mdi-alert-circle
                    </v-icon>
                </a>
                <span class="pl-1">{{ typename }}</span>
            </div>
            <v-spacer />
            <div class="status">
                {{ attachment.status.name }}
            </div>
            
            <div class="quality" :class="attachment.quality.color">

            </div>
            <v-tooltip v-if="attachment.adpStatus" bottom>
                <template v-slot:activator="{ on }">
                    <v-icon
                        v-on   = "on"
                        small
                        :color = "adpStatusColor"
                        style  = "margin-top: -1px"
                        class  = "pl-1"
                    >
                        {{ adpStatusIcon }}
                    </v-icon>
                </template>
                <span>{{ adpStatusTooltip }}</span>
            </v-tooltip>
        </div>

        <div v-if="attachment && unit" class="unit">
            <span class="pr-1">{{ unit.fabricNo }}</span>
            <span class="pr-1">{{ unit.street }},</span>
            <span class="pr-1">{{ unit.zip }}</span>
            <span class="pr-1">{{ unit.city }}</span>
            <span v-if="unitCount > 1">(+ {{ unitCount - 1 }} weitere Anlagen)</span>
        </div>
        <div v-if="attachment && !unit" class="unit">
            <span class="pr-1"></span>
        </div>
        <div v-if="!attachment">

        </div>
    </div>
</template>

<script>
import Core from "@/modules/core/service/Core";
import Inb from "@/modules/inb/service/Inb";

export default {
    name: "CImportAttachment",
    components: {

    },
    props: {
        value: {

        },

        isSelected: {

        }
    },

    data: () => ({
        attachment : null,
    }),

    created () {
        this.$bus.$on(Inb.event.attachment, (data) => {
            if (data.id === this.attachment.id) {
                this.attachment = data;
            }
        })
    },

    mounted() {
        this.attachment = this.value;
    },

    computed: {
        unit () {
            if (this.attachment && this.attachment.sites.length > 0) {
                return this.attachment.sites[0];
            }

            return null;
        },

        unitCount () {
            if (!this.attachment || !this.attachment.sites) {
                return 0;
            }

            return this.attachment.sites.length;
        },

        icon () {
            return Inb.message.isEmail (this.attachment) ? "mdi-email-outline" : "mdi-file-pdf-box";
        },


        typename () {
            if (this.attachment.type.id === "DEFAULT" && Inb.message.isEmail (this.attachment)) {
                return "Mail";
            }

            return this.attachment.type.name;
        },

        adpStatusIcon () {
            switch (this.attachment.adpStatus) {
                case 'SUCCESS':                  return 'mdi-check-circle';
                case 'ERROR':                    return 'mdi-alert-circle';
                case 'IN_PROGRESS':              return 'mdi-progress-clock';
                case 'INSUFFICIENT_CONFIDENCE':  return 'mdi-help-circle';
                default:                         return 'mdi-help-circle-outline';
            }
        },

        adpStatusColor () {
            switch (this.attachment.adpStatus) {
                case 'SUCCESS':                  return 'success';
                case 'ERROR':                    return 'error';
                case 'IN_PROGRESS':              return 'orange darken-2';
                case 'INSUFFICIENT_CONFIDENCE':  return 'amber darken-2';
                default:                         return 'grey';
            }
        },

        adpStatusTooltip () {
            switch (this.attachment.adpStatus) {
                case 'SUCCESS':                  return this.$t('inb.adp.success');
                case 'ERROR':                    return this.$t('inb.adp.error');
                case 'IN_PROGRESS':              return this.$t('inb.adp.in_progress');
                case 'INSUFFICIENT_CONFIDENCE':  return this.$t('inb.adp.insufficient_confidence');
                default:                         return this.attachment.adpStatus;
            }
        }
    },

    watch: {
        value () {
            this.attachment = this.value;
        },
    },

    methods: {
        onDetail () {
            Core.fire.selected(this, {
                component: this,
                data     : this.attachment
            });
        },
    }
}
</script>

<style scoped>

.inbox-attachment {
    margin-bottom: 2px;
    font-size: 14px;
    height: 42px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 7px;
    line-height: 13px;
    cursor: pointer;
    background-color: #f5f5f5;
}

.inbox-attachment .unit {
    font-size: 11px;
    padding-top: 3px;
}

.inbox-attachment .status {
    font-size: 11px;
    padding-top: 0;
}

.inbox-attachment .quality {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    margin-top: 1px;
    margin-left: 3px;
}

</style>